"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approvalResubmitResponseSchema = exports.approvalResubmitPreviewResponseSchema = exports.approvalResubmitPreviewMatchSchema = exports.resubmitPathSchema = exports.RESUBMIT_PATHS = void 0;
const zod_1 = require("zod");
const approval_rules_1 = require("./approval-rules");
const approval_inbox_1 = require("./approval-inbox");
const submit_ticket_for_approval_1 = require("./submit-ticket-for-approval");
exports.RESUBMIT_PATHS = ['same_rule', 'different_rule', 'no_match'];
exports.resubmitPathSchema = zod_1.z.enum(exports.RESUBMIT_PATHS);
exports.approvalResubmitPreviewMatchSchema = zod_1.z.object({
    outcome: zod_1.z.literal('match'),
    same_rule: zod_1.z.boolean(),
    rule: submit_ticket_for_approval_1.approvalRuleSnapshotSchema,
});
exports.approvalResubmitPreviewResponseSchema = zod_1.z.discriminatedUnion('outcome', [
    exports.approvalResubmitPreviewMatchSchema,
    zod_1.z.object({ outcome: zod_1.z.literal('no_match') }),
]);
const workflowSnapshotSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    rule_id: zod_1.z.string().uuid().nullable(),
    rule_label: zod_1.z.string().nullable(),
    required_approvers: zod_1.z.array(approval_rules_1.pgApproverRoleSchema),
    mode: approval_rules_1.approvalModeSchema,
    cycle: zod_1.z.number().int().min(1),
});
exports.approvalResubmitResponseSchema = zod_1.z.object({
    path: exports.resubmitPathSchema,
    entity_type: approval_rules_1.approvalEntityTypeSchema,
    entity_id: zod_1.z.string(),
    previous_workflow_id: zod_1.z.string().uuid(),
    active_workflow: workflowSnapshotSchema.nullable(),
    entity_status: zod_1.z.string(),
    approval_status: approval_inbox_1.approvalInboxStatusSchema.nullable(),
});
//# sourceMappingURL=approval-resubmit.js.map